import React from "react";

const TextInfo = ({ text, hoverText, isOptional, containerClassNames, textClassNames }) => {
   return (
      <div className={containerClassNames}>
         <p className={textClassNames}>
            {text}
            {isOptional && <span className="optional"> (obligatoriu)</span>}
         </p>
         <span data-hover={hoverText} className="hovertext ms-2">
            <img alt="" src={require("assets/images/info.png")} />
         </span>
      </div>
   );
};

export default TextInfo;
